<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      class="p-5 text-center"
    >
      <h2>{{ messages.title }} {{ id }}</h2>
      <b-alert
        v-if="errorMessage"
        variant="danger"
        show
      >
        {{ errorMessage }}
      </b-alert>
      <b-alert
        v-if="successMessage"
        variant="success"
        show
      >
        {{ successMessage }}
      </b-alert>

      <p
        v-if="redirectCountdown > 0"
        class="mt-3"
      >
        Usted será redirigido al inicio en <strong>{{ redirectCountdown }}</strong> segundos...
      </p>
    </b-overlay>
  </div>
</template>

<script>
import checkoutService from '@/services/checkoutService'
import { BAlert, BOverlay } from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
    BAlert,
  },
  data() {
    return {
      show: true,
      id: this.$route.params.id,
      status: this.$route.name === 'checkout-approved' ? 'approved' : 'declined',
      queryData: {},
      errorMessage: null,
      successMessage: null,
      redirectCountdown: 3,
    }
  },
  computed: {
    messages() {
      return {
        approved: {
          success: 'El pago se procesó correctamente.',
          error: 'Hubo un error al procesar el pago.',
          title: 'Procesando Pago ID:',
        },
        declined: {
          success: 'El pago fue rechazado.',
          error: 'Hubo un error al procesar el rechazo del pago.',
          title: 'Procesando Rechazo ID:',
        },
      }[this.status]
    },
  },
  mounted() {
    this.getParams()
    this.processCheckout()
  },
  methods: {
    getParams() {
      this.queryData = this.$route.query
    },
    async processCheckout() {
      if (!this.id) {
        this.errorMessage = "ID de checkout no encontrado"
        this.show = false
        this.initRedirect()

        return
      }

      try {
        await checkoutService.processCheckout(this.id, this.status, this.queryData)
        this.successMessage = this.messages.success

      } catch (error) {
        this.errorMessage = this.messages.error
        console.error("Error:", error)

      } finally {
        this.show = false
        this.initRedirect()
      }
    },
    initRedirect() {
      const countdownInterval = setInterval(() => {
        if (this.redirectCountdown > 0) {
          // eslint-disable-next-line no-plusplus
          this.redirectCountdown--
        } else {
          clearInterval(countdownInterval)
          this.$router.push({ name: "home" })
        }
      }, 1000)
    },
  },
}
</script>
